var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4153 14.6291L17 18.344L13.4153 14.6291ZM15.5455 9.2997C15.5455 13.4622 12.2894 16.8366 8.2728 16.8366C4.25612 16.8366 1 13.4622 1 9.2997C1 5.13719 4.25612 1.76282 8.2728 1.76282C12.2894 1.76282 15.5455 5.13719 15.5455 9.2997Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCrypto);
export default __webpack_public_path__ + "static/media/search_crypto.174efa8e41807df389b69d7bdf0aec24.svg";
export { ForwardRef as ReactComponent };